import { render, staticRenderFns } from "./BiobankCard_EIBIC.vue?vue&type=template&id=0f401654&"
import script from "./BiobankCard_EIBIC.vue?vue&type=script&lang=js&"
export * from "./BiobankCard_EIBIC.vue?vue&type=script&lang=js&"
import style0 from "./BiobankCard_EIBIC.vue?vue&type=style&index=0&id=0f401654&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports